var Primary = require('Decorators').Primary;

var ApplicationState = function () {

      this.GalleryKey           = Primary(String)
     ,this.UserId               = Number
     ,this.QuestionnaireId      = Number
     ,this.CallId               = Number
     ,this.FormId               = Number
     ,this.InCall               = Boolean
     ,this.CallOnBoard          = Boolean
     ,this.QuestionnaireOnBoard = Date
     ,this.CallStored           = Boolean
     ,this.QuestionnaireStored  = Boolean
     ,this.Initialized          = Boolean
     ,this.InitializedOn        = Date
     ,this.LastView             = String
     ,this.SessionId            = String
     ,this.SessionToken         = String
     ,this.InvalidSessionId     = Boolean
     ,this.CreatedOn            = String
     ,this.ExpiresOn            = String
     ,this.RenewableOn          = String
     ,this.FirstAnswerOn        = String
     ,this.LastAnswerOn         = String
     ,this.CallUploaded         = Date
     ,this.CallUploadedOn       = Date


}

module.exports = ApplicationState;
